import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { MainTitle, Paragraph, TextField, WarningAlert } from 'common/components';
import { Button } from 'components/common';
import { Divider } from 'components/styled/Divider';
import { LoginSignupWrapper } from 'components/styled/Form.styled';
import { BackToLoginLink } from 'modules/account/features/forgotPassword/components';
import { useMutationForgotPassword } from 'modules/account/features/forgotPassword/hooks';

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
});

export const ForgotPassword = () => {
  const { t } = useTranslation();
  const { colors, fontFamily } = useTheme();
  const [mailSent, setMailSent] = useState(false);

  const changeView = () => {
    setMailSent(prevState => !prevState);
  };

  const { mutate, status } = useMutationForgotPassword(changeView);

  return (
    <>
      <MainTitle
        fontFamily={fontFamily.semiBold}
        fontSize="2rem"
        fontWeight={600}
        margin="0 0 1.5rem 0"
      >
        {t('Reset password')}
      </MainTitle>
      <Formik
        initialValues={{
          email: '',
        }}
        validationSchema={ForgotPasswordSchema}
        onSubmit={values => {
          const { email } = values;
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          mutate(email);
        }}
      >
        {() => (
          <LoginSignupWrapper>
            <Paragraph
              fontFamily={fontFamily.regular}
              fontSize="0.875rem"
              fontWeight="400"
              letterSpacing="0.006rem"
              margin="0 0 1.25rem 0"
              color={colors.black_80}
            >
              {t(`Enter your email address and we'll send you a link to reset your password.`)}
            </Paragraph>

            <TextField label={t('Email')} name="email" isRequired />

            <Button
              width="100%"
              type="submit"
              label="Send reset link"
              color="blue"
              isFetching={status === 'loading'}
            />

            {mailSent && (
              <WarningAlert
                text={t('The password change request has been successfully sent to your email.')}
                showCloseIcon={false}
                margin="1.25rem 0 0 0"
                confirmInfo
                backgroundColor={colors.white}
              />
            )}

            <Divider margin="1.25rem 0" />

            <BackToLoginLink to="/login">{t('Back to login')}</BackToLoginLink>
          </LoginSignupWrapper>
        )}
      </Formik>
    </>
  );
};
